import React, { useState } from "react";
import styled from "styled-components";
import { colors } from "../maps/colors";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import Icn from "./Icn";

const WrapperStyled = styled.div`
  padding: 0 5px;
`;

const StatusStyled = styled.div`
  border-radius: 50%;
  outline: 1px solid #b5b5b5;
  outline-offset: 0;
  width: 5px;
  height: 5px;
`;

const ContentStatusStyled = styled.div`
  display: grid;
  grid-template-columns: 90px 50px 20px auto;
  align-items: center;
  grid-gap: 5px;
  font-size: 12px;
`;

const ModelsIconStyled = styled.div`
  cursor: pointer;
  display: grid;

  svg {
    width: 15px;
    height: 15px;
  }
`;

const ModelsWrapperStyled = styled.div``;

const ModelItemStyled = styled.div`
  span {
    font-size: 15px;
    margin-right: 10px;
  }

  .value {
    font-size: 13px;
    font-weight: 500;
  }
`;

const STATUS_MAP = {
  communication: {
    name: "communication",
  },
  "floor-ai-system": {
    name: "floor ai",
  },
  "product-ai-system": {
    name: "product ai",
  },
  "product-api-server": {
    name: "product api",
    version: "product-ai-system",
  },
  "shelve-ai-system": {
    name: "shelf ai",
  },
  "udps-api-server": {
    name: "udps api",
    version: "shelve-ai-system",
  },
  "edge-proxy": {
    name: "proxy",
  },
  "alert-watcher": {
    name: "alerts",
  },
  "edge-logic": {
    name: "logic",
  },
  "logic-getway": {
    name: "logic getway",
  },
};

const EdgeStatus = ({ services }) => {
  const [showModels, s_showModels] = useState(false);
  const [models, s_models] = useState([]);

  const closeModal = () => {
    s_showModels(false);
  };

  const keys = Object.keys(services);

  return (
    <WrapperStyled>
      {keys.map((key) => {
        const statusContent = services[key];
        const dataItem = STATUS_MAP[key];
        const isHealthy =
          statusContent.healthCheckTimestamp + 220000 > Date.now();

        const style = {
          background: isHealthy ? colors.LIME : colors.RED1,
        };

        let version = statusContent?.version || "N/A";
        if (dataItem?.version) {
          if (services[dataItem.version]) {
            version = services[dataItem.version].version;
          }
        }
        const hasModel = statusContent.modelVersions?.length > 0;

        return (
          <ContentStatusStyled key={key}>
            <span>{dataItem?.name || key}</span>
            <span>
              <b>{version}</b>
            </span>
            <StatusStyled style={style} />
            {hasModel && (
              <ModelsIconStyled
                onClick={() => {
                  s_models(statusContent.modelVersions);
                  s_showModels(true);
                }}
              >
                <Icn>modelTrainingIcon</Icn>
              </ModelsIconStyled>
            )}
          </ContentStatusStyled>
        );
      })}

      <Dialog maxWidth="md" open={showModels} onClose={closeModal}>
        <ModelsWrapperStyled>
          <DialogTitle id="asditle">Model versions</DialogTitle>
          <DialogContent>
            {models.map((k) => {
              return (
                <ModelItemStyled key={k.value}>
                  <span className="name">{k.name}:</span>
                  <span className="value">{k.value}</span>
                </ModelItemStyled>
              );
            })}
          </DialogContent>
        </ModelsWrapperStyled>
      </Dialog>
    </WrapperStyled>
  );
};

export default EdgeStatus;
